import { render, staticRenderFns } from "./ServiceProtocolDescription.vue?vue&type=template&id=0466f474&scoped=true&"
import script from "./ServiceProtocolDescription.vue?vue&type=script&lang=js&"
export * from "./ServiceProtocolDescription.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProtocolDescription.vue?vue&type=style&index=0&id=0466f474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466f474",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardSubtitle,VIcon,VList,VListItem,VListItemAction,VListItemContent,VTextField,VTextarea})
